import React from 'react'
import ScheduleSection from "../../widgets/scheduleSection/ScheduleSection";
import ReviewsSection from "../../widgets/reviewsSection/reviewsSection";
import FormSection from "../../widgets/formSection/FormSection";
import HeroSection from "../../widgets/HeroSection/HeroSection";
import AboutSection from "../../widgets/aboutSection/AboutSection";
import CatalogSection from "@/widgets/catalog/CatalogSection/CatalogSection.jsx";
import {MainLayout} from "../../layouts/main";
import LoyaltySystem from "@/widgets/loyaltySystem/LoyaltySystem.jsx";
import PrivateGamesSection from "@/widgets/privateGames/PrivateGamesSection.jsx";

export default function HomePage() {
    return(
        <MainLayout>
        <>
            <HeroSection/>
            <AboutSection />
            <LoyaltySystem />
            <ScheduleSection />
            <PrivateGamesSection/>
            <ReviewsSection />
            <FormSection />
        </>
        </MainLayout>
    )
}